import BoxState from '../../scripts/lib/box-state.js'

class ProductBuyBox extends HTMLElement {
  #boxState = null
  #quantityComponent = null
  #addButton = null
  #formEl = null

  constructor() {
    super()
    this.handleAddToBox = this.handleAddToBox.bind(this)
  }

  connectedCallback() {
    this.#boxState = BoxState.getInstance()
    this.#cacheElements()
    this.setupEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  #cacheElements() {
    this.#quantityComponent = this.querySelector('v-quantity')
    this.#addButton = this.querySelector('[data-add-to-box]')

    const formId = this.dataset.formId
    if (formId) {
      this.#formEl = document.getElementById(formId)
    }
  }

  setupEventListeners() {
    if (this.#addButton) {
      this.#addButton.addEventListener('click', this.handleAddToBox)
    }
  }

  removeEventListeners() {
    if (this.#addButton) {
      this.#addButton.removeEventListener('click', this.handleAddToBox)
    }
  }

  handleAddToBox() {
    const variantId = this.#getSelectedVariantId()
    const quantity = parseInt(this.#quantityComponent?.dataset.value || '1', 10)

    this.#boxState.setBoxItem(variantId, { quantity })

    const collection = this.dataset.collection
    const url = collection && collection !== 'all' ? `/cart?tab=${collection}` : '/cart'
    window.location.href = url
  }

  #getSelectedVariantId() {
    if (this.#formEl) {
      const hiddenInput = this.#formEl.querySelector('input[name="id"]')
      if (hiddenInput && hiddenInput.value) {
        return hiddenInput.value
      }
    }

    return this.dataset.variantId
  }
}

if (!customElements.get('product-buy-box')) {
  customElements.define('product-buy-box', ProductBuyBox)
}

export default ProductBuyBox